import { useEffect } from 'react';
import { useGameStore } from '@/state/gameStore';
import { loadWaterFeatures } from '@/data/waterFeatures';
import { getRadiusKm } from '@/data/leveling';

/**
 * Phase 13.7 — Loads OSM open-water features (rivers, lakes, canals) for the
 * current home city. Mirrors `useNpcStationsLoader` and `useHydrantsLoader`.
 */
export function useWaterFeaturesLoader() {
  const homeCity = useGameStore((s) => s.homeCity);
  const level = useGameStore((s) => s.level);
  const setWaterFeatures = useGameStore((s) => s.setWaterFeatures);

  useEffect(() => {
    if (!homeCity) return;
    const ctrl = new AbortController();
    const radiusKm = getRadiusKm(level);
    void loadWaterFeatures(homeCity.center, radiusKm, ctrl.signal).then((features) => {
      if (ctrl.signal.aborted) return;
      setWaterFeatures(features);
    });
    return () => ctrl.abort();
  }, [homeCity, level, setWaterFeatures]);
}
